<template>
  <!-- TOP Nav Bar -->
  <div class="iq-top-navbar">
    <div :class="
      horizontal ? 'd-flex align-items-center justify-content-between' : ''
    " class="iq-navbar-custom">
      <div v-if="horizontal" class="iq-menu-horizontal">
        <div class="iq-sidebar-menu">
          <List :horizontalMenuSetting="horizontalMenuSetting" :items="items" :user="user" :wallet="wallet"
            class="d-flex"></List>
        </div>
      </div>
      <nav class="navbar navbar-expand-lg navbar-light p-0">
        <slot name="logo" />
        <List :horizontalMenuSetting="horizontalMenuSetting" :items="items" :user="user" :wallet="wallet"
          class="d-flex"></List>
        <b-collapse id="nav-collapse" is-nav>
          <slot name="responsiveRight" />
        </b-collapse>
        <slot name="right" />
      </nav>
    </div>
  </div>
  <!-- TOP Nav Bar END -->
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import List from "../menus/ListStyle";
import SideBarItems from "../../../json/SideBar";

import userService from "../../../services/user";
import utilsService from "../../../services/utils";

export default {
  name: "NavBar",
  props: {
    title: { type: String, default: "Dashboard" },
    logo: { type: String },
    horizontal: { type: Boolean, default: false },
    organization: { default: null },
    items: { type: Array },
    horizontalMenuSetting: Array,
    wallet: Object,
  },
  mounted() {
    this.getUser();
    document.addEventListener("click", this.closeSearch, true);
  },
  components: {
    List,
  },
  computed: {
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  data() {
    return {
      user: {},
      defaultAvatar: true,
      sidebar: SideBarItems,
      globalSearch: "",
      file: "",
      showSearch: false,
      showMenu: false,
    };
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    miniSidebar() {
      this.$emit("toggle");
    },
    getUser() {
      let self = this;
      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    getLogo(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../../../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../../../assets/images/logo.png");
        });
    },
  },
};
</script>
